<template>
    <el-drawer class="w-el-drawer" :visible.sync="visible" :size="960" :with-header="false" direction="rtl" :before-close="Close" append-to-body destroy-on-close>
        <div class="w-el-drawer-header">
            <i class="el-icon-tickets"></i> 项目变更
        </div>
        <div class="w-el-drawer-body"  v-loading="loading">
            <el-form :model="projects" label-width="120px" size="mini">
                <el-form-item label="关联合同">
                    <crm-contract-select v-model="projects.contract_id" />
                </el-form-item>
                <el-form-item label="项目名称" :rules="[{ required: true, message: '请填写项目名称' }]" :error="projectsError.name?.toString()" prop="name">
                    <el-input v-model="projects.name" placeholder="X省X市XXxx项目" clearable />
                </el-form-item>
                <el-form-item label="项目编号" :rules="[{ required: true, message: '请填写项目编号' }]" :error="projectsError.number?.toString()" prop="number">
                    <el-input v-model="projects.number" placeholder="CXXXXXX" clearable />
                </el-form-item>
                <el-form-item label="项目类型" :rules="[{ required: true, message: '请选择项目类型' }]" :error="projectsError.type?.toString()" prop="type">
                    <projects-type-select v-model="projects.type" clearable filterable multiple width="350px" />
                </el-form-item>
                <el-form-item label="项目周期" :rules="[{ required: true, message: '请选择项目周期' }]" :error="projectsError.start_date?.toString()" prop="start_date">
                    <el-date-picker
                        @change="StartSateChange()"
                        v-model="projects.start_date"
                        type="daterange"
                        align="right"
                        value-format="yyyy-MM-dd"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="项目描述" >
                    <froala-editor v-model="projects.describe" />
                </el-form-item>
                <el-form-item label="访问控制" :error="projectsError.jurisdiction?.toString()" prop="jurisdiction">
                    <el-radio-group v-model="projects.jurisdiction">
                        <el-tooltip effect="dark" content="有目代视图权限，即可访问" placement="top-start">
                            <el-radio :label="1">默认设置</el-radio>
                        </el-tooltip>
                        <el-tooltip effect="dark" content="只有项目团队成员才能访问" placement="top-start">
                            <el-radio :label="2">私有项目</el-radio>
                        </el-tooltip>
                        <el-tooltip effect="dark" content="团队成员和白名单的成员可以访问" placement="top-start">
                            <el-radio :label="3">自定义白名单</el-radio>
                        </el-tooltip>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="访问白名单" v-if="projects.jurisdiction == 3">
                    <config-role-select v-model="projects.jurisdiction_role" />
                </el-form-item>
            </el-form>
        </div>
        <div class="w-el-drawer-footer">
            <el-button size="medium" @click="Close()">取消 / 返回</el-button>
            <el-button size="medium" type="primary" @click="ProjectsEdit()" :loading="loading">确认变更</el-button>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            loading: false,
            projectsError: {},
            projects: {
                id: null,
                name: null,
                number: null,
                sale: null,
                type: null,
                contract_id: null,
                start_date: null,
                describe: null,
                jurisdiction: 1,
                jurisdiction_role: []
            },
            projectsType: [],
        }
    },
    methods: {
        Open(id) {
            this.loading = true
            this.visible = true
                        this.$http.post('/9api/projects/first', { id: id }).then(async rps => {
                this.projects.id = rps.data.id
                this.projects.name = rps.data.name
                this.projects.number = rps.data.number
                this.projects.type = rps.data.type
                this.projects.contract_id = rps.data.contract_id
                this.projects.start_date = rps.data.start_date
                this.projects.jurisdiction = rps.data.jurisdiction
                this.projects.jurisdiction_role = rps.data.jurisdiction_role
                this.projects.describe = rps.data.describe
                this.loading = false
            })
        },
        Close() {
            this.visible = false
            this.loading = false
        },
        StartSateChange() {
            const start_date = new Date(this.projects.start_date[0])
            const end_date = new Date(this.projects.start_date[1])
            this.projects.working_days = ((end_date.getTime() - start_date.getTime()) / 86400 / 1000) + 1
        },
         ProjectsEdit() {
                        this.loading = true
            this.projectsError = {}
            this.$http.post('/9api/projects/edit', this.projects).then(rps => {
                this.loading = false
                if (rps.data.status == 'error') {
                    this.projectsError = rps.data.error
                }
                if (rps.data.status == 'success') {
                    this.$notify.success({
                        title: '提示',
                        message: rps.data.success,
                        duration: 2000
                    })
                    this.$emit("success")
                    this.Close()
                }
            })
        }
    }
}
</script>